import { useState } from 'react';

import { PullsFilter } from './pulls-filter';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Filter } from '@/types/filters';

interface SavedViewCreatorProps {
  filters: Filter[];
  setFilters: (filters: Filter[] | ((prevFilters: Filter[]) => Filter[])) => void;
  repositories: string[];
  authors: Array<{ login: string; avatarUrl?: string }>;
  reviewers?: Array<{ login: string; avatarUrl?: string }>;
  onSave: (name: string) => void;
  onCancel: () => void;
}

export function SavedViewCreator({
  filters,
  setFilters,
  repositories,
  authors,
  reviewers,
  onSave,
  onCancel,
}: SavedViewCreatorProps) {
  const [viewName, setViewName] = useState('');
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);

  const handleSave = () => {
    if (viewName.trim()) {
      onSave(viewName.trim());
    }
  };

  return (
    <div className="border-b bg-muted/20">
      <div className="px-8 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1">
            <Input
              placeholder="View name"
              value={viewName}
              onChange={(e) => setViewName(e.target.value)}
              className="w-full text-base font-medium"
              autoFocus
            />
          </div>
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="sm" onClick={onCancel}>
              Cancel
            </Button>
            <Button 
              size="sm" 
              onClick={handleSave} 
              disabled={!viewName.trim() || filters.length === 0}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
      
      {/* Filter section */}
      <div className="px-8 pb-4">
        <div className="flex items-center gap-4">
          <PullsFilter
            repositories={repositories}
            authors={authors}
            reviewers={reviewers}
            filters={filters}
            setFilters={setFilters}
            open={filterDropdownOpen}
            onOpenChange={setFilterDropdownOpen}
          />
          {filters.length > 0 && (
            <div className="text-sm text-muted-foreground">
              {filters.length} filter{filters.length !== 1 ? 's' : ''} applied
            </div>
          )}
        </div>
      </div>
    </div>
  );
}